'use strict';

const CONSTANTS = require('../constants/constants');
const FlutterHelper = require('../helpers/flutterHelper');

/**
 * Mobile / Flutter: purchase event for bought gift cards only.
 */
class PurchaseGiftCardAnalytics {

    constructor(eventData) {
        this.eventData = eventData;
    }

    pushEvent() {
        if (!this.eventData.giftCard_quantity || this.eventData.giftCard_quantity < 1) {
            return false;
        }

        var resetCart = this.eventData.skipFlutterReset !== true;

        FlutterHelper.sendEvent(CONSTANTS.ANALYTICS_EVENTS.PURCHASE_GIFT_CARD, {
            giftCard_SKU: this.eventData.giftCard_SKU || '',
            giftCard_category: this.eventData.giftCard_category || 'GIFT CARD',
            giftCard_quantity: this.eventData.giftCard_quantity,
            giftCard_transaction_id: this.eventData.giftCard_transaction_id || '',
            giftCard_value: this.eventData.giftCard_value,
            giftCard_variant: this.eventData.giftCard_variant || ''
        }, resetCart);
    }
}

module.exports = PurchaseGiftCardAnalytics;
